import React from "react";

function BandIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#clip0_1169_5978)">
        <path
          fill="#fff"
          d="M7.159 9.406c-.25.469-.188 1.094.093 1.5.094.094.188.25.282.375l-.344.875a3.619 3.619 0 00-.063 2.5c-.03.031-.062.094-.093.125C6.314 15.531 5.19 16 3.97 16c-2.187 0-4-1.469-3.969-3.281-.03-.656.25-1.281.657-1.813.312-.406.375-1.031.156-1.5a2.638 2.638 0 01-.25-1.062c0-.719.281-1.313.75-1.781a2.8 2.8 0 01.594-.47c.406-.25.875-.374 1.343-.437V3.97l-.53-1.031a.962.962 0 01-.095-.407V.844c0-.469.375-.844.813-.844h1.094c.437 0 .812.375.812.844V2.53c0 .125-.062.281-.094.406l-.5 1.032v1.687c.47.063.907.188 1.313.438.812.531 1.344 1.312 1.344 2.218 0 .376-.094.75-.25 1.094zm-2.282 1c.47-.5.47-1.281 0-1.781a1.304 1.304 0 00-1.78 0 1.304 1.304 0 000 1.781c.5.469 1.28.469 1.78 0zm10.907 2.125c.687 1.656-.5 3.469-2.282 3.469h-3.03c-1.782 0-3-1.813-2.25-3.438l.812-2.312A2.27 2.27 0 008.97 8.5a2.435 2.435 0 01-.187-.969V5.97c0-.282.187-.5.437-.532a.499.499 0 01.594.344l.406 1.125c.094.375.375.594.75.688h.25V4.719L10.502 4a.758.758 0 01-.25-.75c.594-2.594.5-2.656 1-3.031.563-.344 1.282-.25 1.688.25.406.531.375 1.25-.063 1.719-.062.062-.125.093-.156.124v5.313l.281.031a1.14 1.14 0 00.813-.593l.344-.657a.59.59 0 01.656-.281c.25.063.437.25.437.531v.907c0 .312-.062.625-.187.937a2.144 2.144 0 00-.094 1.75l.813 2.281zm-2.313-.281v-.5c0-.125-.094-.25-.219-.25h-2.5c-.093 0-.218.125-.218.25v.5c0 .156.093.25.218.25h2.5c.094 0 .22-.094.22-.25zm0-2v-.5c0-.125-.094-.25-.219-.25h-2.5c-.093 0-.218.125-.218.25v.5c0 .156.093.25.218.25h2.5c.094 0 .22-.094.22-.25z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1169_5978">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.memo(BandIcon);
